import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { isPaypalSettingsOpened } from 'client/reducers/managementReducer'
import { useManagement } from 'client/store'
import Button from 'common/components/entities/Button/button'
import { PaypalPreviewButton } from 'common/components/entities/paypal-rest-button/preview-button'
import { PaymentButtonInterface } from 'common/types/entities/PaymentButtonInterface'
import React from 'react'
import { useButton } from 'src/editor/shared/hooks/use-button'
import { useSelectedButtonColor } from 'src/editor/shared/hooks/use-theme-color/use-selected-button-color'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'

export interface PaymentButtonProps {
  entity: PaymentButtonInterface
  isMoveDownAllowed: boolean
  isMoveUpAllowed: boolean
  isRemoveAllowed: boolean
  isSaveAllowed: boolean
  isCopyAllowed: boolean
  dropBoxAllowedEntityIds?: string[]
}

const PaymentButtonNew = ({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
  isRemoveAllowed,
  isSaveAllowed,
  isCopyAllowed,
  dropBoxAllowedEntityIds,
}: PaymentButtonProps) => {
  const showPaypalSettings = useManagement(isPaypalSettingsOpened)

  const {
    calculatedBorder,
    calculatedPadding,
    calculatedFontSize,
    calculatedLineHeight,
    // calculatedTextAlign,
    // calculatedLetterSpacing,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
  } = useButton({
    border: entity.border,
    mobileBorder: entity.mobileBorder,
    padding: entity.padding,
    mobilePadding: entity.mobilePadding,
    buttonType:
      entity.buttonType || WebsiteSettingsTypographyTypeEnum.PrimaryButton,
    fontSize: entity.textFontSize,
    mobileFontSize: entity.mobileTextFontSize,
    lineHeight: entity.lineHeight,
    mobileLineHeight: entity.mobileLineHeight,
    fontFamily: entity.textFontFamily,
    mobileFontFamily: entity.mobileTextFontFamily,
    fontWeight: entity.textFontWeight,
    mobileFontWeight: entity.mobileTextFontWeight,
    fontStyle: entity.textFontStyle,
    mobileFontStyle: entity.mobileTextFontStyle,
  })
  const {
    buttonTextColor,
    buttonBackgroundColor,
    hoveredButtonBackgroundColor,
  } = useSelectedButtonColor(
    entity.buttonType || WebsiteSettingsTypographyTypeEnum.PrimaryButton,
  )

  return (
    <BaseEntityNew
      entity={entity}
      flex
      flexColumn
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
      isRemoveAllowed={isRemoveAllowed}
      isSaveAllowed={isSaveAllowed}
      isCopyAllowed={isCopyAllowed}
      dropBoxAllowedEntityIds={dropBoxAllowedEntityIds}
    >
      {showPaypalSettings ? (
        <PaypalPreviewButton type={entity.paypal?.backgroundColor} />
      ) : (
        <Button
          attrId={entity.htmlAttrId}
          text={entity.text}
          subText={entity.subText}
          width={entity.width}
          mobileWidth={entity.mobileWidth}
          padding={calculatedPadding.desktop}
          mobilePadding={calculatedPadding.mobile}
          border={calculatedBorder.desktop}
          mobileBorder={calculatedBorder.mobile}
          alignSelf={entity.alignSelf}
          mobileAlignSelf={entity.mobileAlignSelf}
          textColor={entity.textColor || buttonTextColor}
          mobileTextColor={entity.mobileTextColor || buttonTextColor}
          textFontSize={calculatedFontSize.desktop}
          mobileTextFontSize={calculatedFontSize.mobile}
          lineHeight={calculatedLineHeight.desktop}
          mobileLineHeight={calculatedLineHeight.mobile}
          textFontFamily={calculatedFontFamily.desktop}
          textFontStyle={calculatedFontStyle.desktop}
          textFontWeight={calculatedFontWeight.desktop}
          subTextFontSize={entity.subTextFontSize}
          mobileSubTextFontSize={entity.mobileSubTextFontSize}
          subTextColor={entity.subTextColor}
          mobileSubTextColor={entity.mobileSubTextColor}
          subTextFontFamily={entity.subTextFontFamily}
          subTextFontStyle={entity.subTextFontStyle}
          subTextFontWeight={entity.subTextFontWeight}
          boxShadow={entity.boxShadow}
          mobileBoxShadow={entity.mobileBoxShadow}
          hover={{
            ...entity.hover,
            backgroundColor:
              entity?.hover?.backgroundColor || hoveredButtonBackgroundColor,
          }}
          mobileHover={{
            ...entity.mobileHover,
            backgroundColor:
              entity?.mobileHover?.backgroundColor ||
              entity?.hover?.backgroundColor ||
              hoveredButtonBackgroundColor,
          }}
          background={
            (entity.background ?? entity.backgroundColor) ||
            buttonBackgroundColor
          }
          mobileBackground={
            (entity.mobileBackground ?? entity.mobileBackgroundColor) ||
            buttonBackgroundColor
          }
          iconClassNameBefore={entity.iconClassNameBefore}
          iconClassNameAfter={entity.iconClassNameAfter}
        />
      )}
    </BaseEntityNew>
  )
}
export default PaymentButtonNew
